/**
 * Created by draplater on 17-7-14.
 */

import * as React from 'react';
import {Panel, Row, Col} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {GlobalState} from "./reduxSetting";
import {RouteComponentProps} from "react-router";
import {connect} from "react-redux";
import {FrameMeta} from "./problem-domain/frame";

interface MenuProps {
    frame: FrameMeta,
    is_root: boolean,
    path: string[]
}

export class Menus extends React.Component<MenuProps,
    { expanded: boolean }> {
    constructor(props: { frame: FrameMeta, is_root: boolean, path: string[] }) {
        super(props);
        this.state = {expanded: false};
    }

    toggle(): void {
        this.setState({expanded: !this.state.expanded});
    }

    render(): JSX.Element {
        return (
            <ul className={this.props.is_root ? "tree" : undefined}>
                <div className="tree-top">
                    <span className="tree-indicator unselectable"
                          onClick={this.toggle.bind(this)}>
                        {this.state.expanded ? "▼" : "►"}
                    </span>
                    {this.renderLink()}
                </div>
                {this.state.expanded ? this.renderChildren() : null}
            </ul>
        );
    }

    renderChildren(): JSX.Element[] {
        if (this.props.frame.sub_frames.length || this.props.frame.lexicons.length) {
            return [

                ...this.props.frame.lexicons.map((value) =>
                    <li className="tree-leaf">
                        <Link to={"/lexicon/" + this.props.path.join("/") + "/" + value.replace(".tag", "")}>
                            {value.replace(".tag", "")}
                        </Link>
                    </li>
                ),
                ...this.props.frame.sub_frames.map((value) =>
                    <li className="tree-middle tree__item hasChildren">
                        <Menus frame={value}
                               key={`menu-${this.props.path.join("-")}-${value.name}`}
                               is_root={false}
                               path={this.props.path.concat([value.name])}/>
                    </li>
                ),
            ];
        } else {
            return [<li className="tree-leaf"> (Empty) </li>];
        }
    }

    private renderLink() {
        if (this.props.frame.def) {
            return <Link to={"/frame/" + this.props.path.join("/")}>
                {this.props.frame.name}
            </Link>;
        } else {
            return <a style={{"color": "#a55858", "cursor": "pointer"}} onClick={Menus.newFrameClicked}>
                {this.props.frame.name}
            </a>;
        }
    }

    static newFrameClicked() {
        alert("Definition of this Frame has not been created.");
    }
}

namespace MenuManager {
    export interface Props extends RouteComponentProps<void> {
        frames: FrameMeta[]
    }
}

function mapStateToProps(state: GlobalState, ownProps) {
    return {
        frames: state.index.frames
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

class MenuManager extends React.Component<MenuManager.Props, {}> {
    render(): JSX.Element {
        return <Panel id="sidebar">
            {
                this.props.frames.map(
                    (frame, idx) => <Menus key={`menu-${idx}-root`}
                                           frame={frame} is_root={true} path={[frame.name]}/>)
            }
        </Panel>;
    }
}

export const MenuManagerRedux = connect(mapStateToProps, mapDispatchToProps)(MenuManager);

export class MenuManagerWrapperRedux extends React.Component<{}, {}> {
    render() {
        return <Row>
            <Col xs={12} sm={12} md={6} lg={3}>
                <MenuManagerRedux key="menu-manager"/>
            </Col>
            <Col xs={12} sm={12} md={6} lg={9}>
                {this.props.children}
            </Col>
        </Row>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Menu.tsx